import { NgForOf } from '@angular/common';
import { Directive, Host, Input } from '@angular/core';

interface Item {
	Id: number | string;
}

@Directive({
    selector: '[ngForTrackById]',
    standalone: true,
})
export class NgForTrackByIdDirective<T extends Item> {
	constructor(@Host() private readonly ngFor: NgForOf<T>) {
		this.ngFor.ngForTrackBy = (index: number, item: T) => item?.Id ?? index;
	}
}

@Directive({
    selector: '[ngForTrackByItem]',
    standalone: true,
})
export class NgForTrackByItemDirective<T extends Item> {
	constructor(@Host() private readonly ngFor: NgForOf<T>) {
		this.ngFor.ngForTrackBy = (index: number, item: T) => item ?? index;
	}
}

@Directive({
    selector: '[ngForKey]',
    standalone: true,
})
export class NgForKeyDirective<T> {
	@Input('ngForKey')
	public key: string;

	constructor(@Host() private readonly ngFor: NgForOf<T>) {
		this.ngFor.ngForTrackBy = (index: number, item: T) => (item && item[this.key]) ?? index;
	}
}
